module.exports = {
  google: {
    API_KEY: "AIzaSyDx-vz3w2hLdVYwQ3qYCqCdaAdaHTWzCx4",
    CLIENT_ID:
      "917285006234-siq0jk8papr146078bc8023o2ge2u9aq.apps.googleusercontent.com",
    SECRET: "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",
  },
  facebook: {
    APP_ID: "406752255560808",
  },
}
